import { intl } from "../intl";
import moment from "moment-timezone";

var clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const transcriptGenerator = (transcriptFile) => {
  let data = [];

  if (transcriptFile) {
    data.push(
      `\n${intl.formatMessage({
        id: "transcript.roomName",
        defaultMessage: "Room Name",
      })}:     ${transcriptFile.meetingName} `
    );
    if (transcriptFile.isWebinar) {
      data.push(
        `\n(${intl.formatMessage({
          id: "transcript.isWebinar",
          defaultMessage: "Webinar",
        })})`
      );
    }
    if (transcriptFile.startDate)
      data.push(
        `\n${intl.formatMessage({
          id: "transcript.startDate",
          defaultMessage: "Start Date",
        })}:   ${moment(transcriptFile.startDate).format("yyyy-MM-DD HH:mm")} `
      );
    if (transcriptFile.endDate !== undefined) {
      data.push(
        `\n${intl.formatMessage({
          id: "transcript.endDate",
          defaultMessage: "End Date",
        })}:       ${moment(transcriptFile.endDate).format(
          "yyyy-MM-DD HH:mm"
        )} `
      );
    }
    data.push(`\n`);
    data.push(
      `\n-------------------------------------------------------------------`
    );
    data.push(`\n`);
    data.push(
      `\n${intl.formatMessage({
        id: "transcript.participants",
        defaultMessage: "Participants",
      })}:`
    );
    data.push(`\n`);
    let filteredLogs = [
      ...new Set(transcriptFile.eventLogs.map((p) => p.eventOwner)),
    ];
    filteredLogs.map((p) => {
      data.push(`\n${p} ,`);
    });
    data.push(`\n`);
    data.push(
      `\n-------------------------------------------------------------------`
    );
    data.push(`\n`);
    data.push(
      `\n${intl.formatMessage({
        id: "transcript.eventLogs",
        defaultMessage: "Event Logs",
      })}:`
    );
    data.push(`\n`);
    transcriptFile.eventLogs.map((e) => {
      data.push(
        `\n${moment(e.dateTime)
          .tz(clientTimeZone)
          .format("yyyy-MM-DD HH:mm")} ${e.eventOwner} ${
          e.eventType === "userJoined"
            ? intl.formatMessage({
                id: "transcript.userJoined",
                defaultMessage: "joined",
              })
            : intl.formatMessage({
                id: "transcript.userLeft",
                defaultMessage: "left",
              })
        }`
      );
    });
    data.push(`\n`);
    data.push(
      `\n-------------------------------------------------------------------`
    );
    data.push(`\n`);
    data.push(
      `\n${intl.formatMessage({
        id: "transcript.speakingLogs",
        defaultMessage: "Speaking Logs",
      })}:`
    );
    data.push(`\n`);
    let owners = [];
    var newEvents = [];
    transcriptFile.peerSpeakingEvents.map((e) => {
      if (!owners.includes(e.owner)) {
        owners.push(e.owner);
        newEvents.push({
          owner: e.owner,
          speakingTime: e.speakingTime,
        });
      } else {
        let x = newEvents.find((p) => p.owner === e.owner);
        x["speakingTime"] = x.speakingTime + e.speakingTime;
      }
    });

    newEvents.map((e) => {
      if (e.speakingTime) {
        let minutes = 0;
        if (Math.floor(e.speakingTime / 60) > 0)
          minutes = Math.floor(e.speakingTime / 60);

        if (minutes > 0) {
          data.push(
            `\n${e.owner} ${minutes} ${intl.formatMessage({
              id: "transcript.minutes",
              defaultMessage: "minutes",
            })} ${e.speakingTime % 60} ${intl.formatMessage({
              id: "transcript.speakingSecondsTime",
              defaultMessage: "seconds spoke",
            })}`
          );
        } else {
          data.push(
            `\n${e.owner} ${e.speakingTime} ${intl.formatMessage({
              id: "transcript.speakingSecondsTime",
              defaultMessage: "seconds spoke",
            })}`
          );
        }
      }
    });
  }

  return data;
};
